import React, { useState } from 'react';
import { Box, Text, Icon } from '@spothero/ui';
import IconInfoCircleFilled from '@spothero/icons/info-circle-filled';
import IconChevronRight from '@spothero/icons/chevron-right';
import AddVehicleModal from 'pages/search-transient-event-monthly/components/add-vehicle';
const OversizeNoVehicleSetWarning = () => {
    const [isOpen, setIsOpen] = useState(false);
    const setIsOpenToTrue = () => setIsOpen(true);
    const setIsOpenToFalse = () => setIsOpen(false);
    return (<Box display="flex" alignItems="center" marginTop={-4} marginBottom={4} marginX={-4} padding={4} backgroundColor="background.gray" onClick={setIsOpenToTrue} cursor="pointer" data-testid="OversizeNoVehicleSetWarning">
            <Box width={5} height={5}>
                <Icon as={IconInfoCircleFilled} color="gray.500" width={6} height={6} data-testid="OversizeNoVehicleSetWarning-info-icon"/>
            </Box>
            <Box marginLeft={4}>
                <Text fontSize="sm" fontWeight="semibold" as="strong">
                    Vehicle size restrictions may apply
                </Text>
                <Text fontSize="sm">
                    Add your vehicle details to check if your car fits and view
                    any oversize fees.
                </Text>
            </Box>
            <Icon as={IconChevronRight} width={6} height={6} color="black" data-testid="OversizeNoVehicleSetWarning-right-chevron-icon"/>
            <AddVehicleModal isOpen={isOpen} onClose={setIsOpenToFalse}/>
        </Box>);
};
export default OversizeNoVehicleSetWarning;
